import { Text } from '@/components';
import type { FC } from 'react';
import {
  BaseEdge,
  EdgeLabelRenderer,
  type EdgeProps,
  getBezierPath,
} from 'reactflow';

type Data = {
  label: string;
  variant?: 'default' | 'secondary';
};

export const ArrowEdge: FC<EdgeProps<Data>> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  markerEnd,
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          stroke: data?.variant === 'secondary' ? '#999' : '#000',
          strokeWidth: 2,
        }}
      />
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            width: 100,
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            borderRadius: 5,
          }}
          className="nodrag nopan"
        >
          {data?.label && <Text variant="footnote" text={data.label} />}
        </div>
      </EdgeLabelRenderer>
    </>
  );
};
